import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-scroll';
import { changeNavigationTheme, changeVisibleAccountLinks } from '../../../actions';

const pageComponents = [
  {
    name: 'RealEstateGlobally',
    darkTheme: false,
    isVisibleAccountLinks: true
  },
  {
    name: 'ActiveCountries',
    darkTheme: false,
    isVisibleAccountLinks: true
  },
  {
    name: 'BuildingTypes',
    darkTheme: true,
    isVisibleAccountLinks: true
  },
  {
    name: 'AboutUs',
    darkTheme: true,
    isVisibleAccountLinks: true
  },
  {
    name: 'Team',
    darkTheme: true,
    isVisibleAccountLinks: true
  },
  {
    name: 'Cooperate',
    darkTheme: false,
    isVisibleAccountLinks: true
  },
  {
    name: 'Partners',
    darkTheme: false,
    isVisibleAccountLinks: true
  },
  {
    name: 'Contacts',
    darkTheme: true,
    isVisibleAccountLinks: false
  },
  {
    name: 'ReadyToExplore',
    darkTheme: false,
    isVisibleAccountLinks: true
  },
  {
    name: 'WorldMap',
    darkTheme: false,
    isVisibleAccountLinks: true
  },
  {
    name: 'Data',
    darkTheme: false,
    isVisibleAccountLinks: true
  }
];

class Links extends React.Component {
  handleSetActive = (to, component) => {
    this.props.changeTheme(component.darkTheme);
    this.props.changeVisibleAccountLinks(component.isVisibleAccountLinks);
  };

  render() {
    return (
      <>
        {pageComponents.map((item, index) => (
          <Link key={index}
                activeClass="active" to={item.name} spy={true} smooth={true} duration={500}
                style={{ display: 'none' }}
                offset={-50}
                onSetActive={() => this.handleSetActive(item.name, item)}/>
        ))}
      </>
    );
  }
}

const mapStateToProps = state => ({
  darkTheme: state.topNavigationStyles.darkTheme
});

const mapDispatchToProps = dispatch => ({
  changeTheme: (darkTheme) => dispatch(changeNavigationTheme(darkTheme)),
  changeVisibleAccountLinks: (isVisible) => dispatch(changeVisibleAccountLinks(isVisible)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Links);
